import { call, put, select, takeLatest } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import deliveryAPI from '../../api/delivery';
import { Creators as DeliveryCreators, Types } from '../../reducers/delivery';
import { getCartId } from '../../utils/cookies';
import getState from '../../utils/getState';

function* thirdAuthorizationRequest({ sellerId, third }) {
  try {
    const { cart, customer, app } = yield select(getState);
    const cartId = cart.id || customer.cartId || getCartId();
    const siteId = app.getIn(['config', 'siteId']);

    const data = yield call(deliveryAPI.setThirdParty, siteId, cartId, sellerId, third);

    yield put(DeliveryCreators.thirdsAuthorizationSuccess(sellerId, { ...third, ...data }));
  } catch (error) {
    yield put(DeliveryCreators.thirdsAuthorizationFailed(sellerId, formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.THIRDS_AUTHORIZATION_REQUEST, thirdAuthorizationRequest);
}
